import { render, staticRenderFns } from "./GroupAddress.vue?vue&type=template&id=7d131f06&"
import script from "./GroupAddress.vue?vue&type=script&lang=ts&"
export * from "./GroupAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports